// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from "firebase/firestore"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDccWRY0pl7_fum6utJSyj5jhBHmIyATpQ",
  authDomain: "sensoresapp-f4d54.firebaseapp.com",
  projectId: "sensoresapp-f4d54",
  storageBucket: "sensoresapp-f4d54.appspot.com",
  messagingSenderId: "209906462117",
  appId: "1:209906462117:web:2f5089447b315c84438c4c",
  measurementId: "G-MKC638YJYB"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);